module.exports = __webpack_public_path__ + "static/media/fm1125-rs232-rs485-13.a226719e.jpg";